import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { SessionRepository } from "../repository/SessionRepository";

/** Reads the session-ended reason and clears it, so the banner shows once. */
export default class ConsumeSessionEndedReason extends UseCase<
  string,
  NoParams
> {
  repository: SessionRepository;

  constructor(repository: SessionRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.consumeEndedReason();
}
